module.exports = __webpack_public_path__ + "img/android-chrome-192x192.583d0d03.png";